import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/reopen.svg',
})
export class ReopenIconComponent {}
